module.exports = __webpack_public_path__ + "static/img/zzsypos.775ed8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tab/zzsypos.png
// module id = sy1a
// module chunks = 0